export interface TransformationRow {
  n: string;
  title: string;
  before: string;
  after: string;
}

export const transformationRows: TransformationRow[] = [
  {
    n: '1/4',
    title: 'Planificación',
    before: 'Noches de domingo buscando actividades en videos que no terminan de encajar con tu etapa ni con tu realidad de patio.',
    after: '−85% tiempo. Sesiones listas en tu móvil en solo 2 clics. Ordenadas por etapa de madurez.'
  },
  {
    n: '2/4',
    title: 'Seguridad',
    before: 'Inseguridad al llegar al patio sin saber si lo que preparaste está bien alineado con LOMLOE o si es seguro para ese grupo.',
    after: 'Confianza total. Cada sesión con objetivo, variante desarrollada, indicaciones de cuidado y rúbrica de observación.'
  },
  {
    n: '3/4',
    title: 'Variedad',
    before: 'Los mismos 10 juegos de siempre que los alumnos ya hacen en piloto automático.',
    after: 'Sesiones listas y diferentes. Organizadas por unidades y objetivos de trabajo, variadas y con clara progresión semana a semana.'
  },
  {
    n: '4/4',
    title: 'Energía',
    before: 'Llegas al patio mentalmente agotado de haber organizado todo desde cero mientras intentabas calificar trabajos.',
    after: 'Cero estrés. Llegas con energía para observar realmente a tus alumnos desde el primer minuto.'
  }
];

export interface TransformationFooterStat {
  value: string;
  label: string;
}

export const transformationFooterStats: TransformationFooterStat[] = [
  { value: '+180h', label: 'Ahorradas al año' },
  { value: '2 clics', label: 'Para cada sesión lista' },
  { value: '100%', label: 'Objetivos y observación en cada sesión' }
];
